
export const LOGIN_USER = 'LOGIN_USER'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_DEVICE_DATA = 'SET_DEVICE_DATA'
export const SET_TOTAL_DEVICES = 'SET_TOTAL_DEVICES'
export const SET_TOTAL_VEHICLES = 'SET_TOTAL_VEHICLES'
export const SET_VEHICLE_DATA = 'SET_VEHICLE_DATA'
export const REMOVE_DEVICES = 'REMOVE_DEVICES'
export const REMOVE_USERS = 'REMOVE_USERS'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const REMOVE_VEHICLES = 'REMOVE_VEHICLES'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const RESET_LANGUAGE = 'RESET_LANGUAGE'
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE'
export const RESET_DEFAULT_LANGUAGE = 'RESET_DEFAULT_LANGUAGE'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const SET_ORGANIZATIONS_DATA = 'SET_ORGANIZATIONS_DATA'
export const REMOVE_ORGANIZATIONS = 'REMOVE_ORGANIZATIONS'
export const SET_DEVICE_INFO = "SET_DEVICE_INFO";
export const CLEAR_DEVICE_INFO = "CLEAR_DEVICE_INFO";
export const SET_FILTERED_VEHICLES = 'SET_FILTERED_VEHICLES';
export const CLEAR_FILTERED_VEHICLES = 'CLEAR_FILTERED_VEHICLES';
export const SET_ORGANIZATION_FILTER = 'SET_ORGANIZATION_FILTER';
export const SET_DEVICE_FILTER = 'SET_DEVICE_FILTER';
export const SET_USERS_FILTER = 'SET_USERS_FILTER';
export const CLEAR_DEVICE_FILTER = 'CLEAR_DEVICE_FILTER';
export const CLEAR_USER_FILTER = 'CLEAR_USER_FILTER';
export const CLEAR_VEHICLE_FILTER = 'CLEAR_VEHICLE_FILTER';
export const USERS_ADMIN_FILTER = 'USERS_ADMIN_FILTER';
export const CLEAR_USERS_ADMIN_FILTER = 'CLEAR_USERS_ADMIN_FILTER';
export const SET_DEVICE_FILTER_DATA = 'SET_DEVICE_FILTER_DATA';
export const SET_VEHICLE_FILTER_DATA = 'SET_VEHICLE_FILTER_DATA';
export const SET_FILTER_USER_DATA = 'SET_FILTER_USER_DATA';
export const SET_MONTH_STATS = 'SET_MONTH_STATS'
export const CLEAR_MONTH_STATS = 'CLEAR_MONTH_STATS'
export const SET_PEOPLE_COUNTER_DATA = 'SET_PEOPLE_COUNTER_DATA'
export const CLEAR_PEOPLE_COUNTER_DATA = 'CLEAR_PEOPLE_COUNTER_DATA'
export const SET_VEHICLE_PAGE_NUMBER = 'SET_VEHICLE_PAGE_NUMBER'
export const SET_DEVICE_PAGE_NUMBER = 'SET_DEVICE_PAGE_NUMBER'
export const SET_USER_PAGE_NUMBER = 'SET_USER_PAGE_NUMBER'
export const SET_PEOPLE_COUNTER_PAGE_NUMBER = 'SET_PEOPLE_COUNTER_PAGE_NUMBER'
export const SET_ORG_PAGE_NUMBER = 'SET_ORG_PAGE_NUMBER'
export const SET_ALL_ORGANIZATION = 'SET_ALL_ORGANIZATION'
export const SET_DEVICE_TYPE_FILTER = "SET_DEVICE_TYPE_FILTER"
export const SET_DEVICE_PERCENTAGE = "SET_DEVICE_PERCENTAGE"
export const SET_VEHICLE_PERCENTAGE = "SET_VEHICLE_PERCENTAGE"
export const SET_USER_PERCENTAGE = "SET_USER_PERCENTAGE"
export const SET_AVAILABLE_SERIAL_NUMBERS = 'SET_AVAILABLE_SERIAL_NUMBERS';
export const SET_TOTAL_FILTERED_VEHICLES = 'SET_TOTAL_FILTERED_VEHICLES';
export const SET_TOTAL_FILTERED_DEVICES = 'SET_TOTAL_FILTERED_DEVICES';
export const SET_TOTAL_FILTERED_USERS = 'SET_TOTAL_FILTERED_USERS ';
export const SET_BUS_LED_DATA = "SET_BUS_LED_DATA";
export const SET_ALL_LINES = "SET_ALL_LINES";
export const SET_ALL_LINES_DIRECTIONS = "SET_ALL_LINES_DIRECTIONS";
export const SET_TOTAL_BUS_LED = "SET_TOTAL_BUS_LED";
export const REMOVE_BUS_LED = "REMOVE_BUS_LED";
export const SET_EDIT_PANEL = "SET_EDIT_PANEL";
export const CLEAR_EDIT_PANEL = "CLEAR_EDIT_PANEL";
export const SET_BUS_LED_ALL_DATA = "SET_BUS_LED_ALL_DATA";
export const SET_BUS_LED_PAGE = "SET_BUS_LED_PAGE";
export const SET_BUS_LED_PAGE_SIZE = "SET_BUS_LED_PAGE_SIZE";
export const SET_ORGANIZATION_COUNT = "SET_ORGANIZATION_COUNT";
export const SET_USERS_COUNT = "SET_USERS_COUNT";
export const SET_DEVICE_COUNT = "SET_DEVICE_COUNT";
export const SET_DEVICE_TYPE_COUNT = "SET_DEVICE_TYPE_COUNT";
export const SET_IP_ADDRESS = "SET_IP_ADDRESS";
export const SET_PANEL_COUNT = "SET_PANEL_COUNT";